
import { mxCell, mxCellState, mxGraphView } from 'mxgraph-js';
import HCLVertexState from '../HCLCellState/HCLVertexState';
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';

class HCLMxGraphView extends mxGraphView {
  public createState(cell: mxCell): mxCellState {
    if (cell instanceof HCLTreeVertex) {
      return new HCLVertexState(this, cell, null);
    }
    return super.createState(cell);
  }
}

export default HCLMxGraphView;
